import req from '../http.js';

// 新增或修改kafka集群
export const addOrEditKafka = (params) => {
  return req('post', '/console/pipeline-kafka-cluster/addOrEdit', params);
};

// 删除kafka集群
export const deleteKafkaCluster = (params) => {
  return req('get', '/console/pipeline-kafka-cluster/deleteKafkaCluster', {
    ...params
  });
};

// 获取Kafka集群详情
export const getKafkaDetail = (params) => {
  return req('get', '/console/pipeline-kafka-cluster/getDetail', {
    ...params
  });
};

// 查询kafka集群列表
export const getKafkaList = (params) => {
  return req('get', '/console/pipeline-kafka-cluster/getList', params);
};

// 添加或修改Partition
export const addOrEditPartition = (params) => {
  return req('post', '/console/pipeline-partition/addOrEdit', params);
};

// 删除Partition
export const deletePartition = (params) => {
  return req('get', '/console/pipeline-partition/deletePartition', {...params});
};

// 获取Partition列表
export const getPartitionTableList = (params) => {
  return req('get', '/console/pipeline-partition/getList', {
    ...params
  });
};

// 根据topicID获取pattition列表
export const getListByTopicID = (params) => {
  return req('get', '/console/pipeline-partition/getListByTopicID', {
    ...params
  });
};

// 增加或修改Topic
export const addOrEditPipelineTopic = (params) => {
  return req('post', '/console/pipeline-topic/addOrEdit', params);
};
// 删除Topic
export const deleteTopic = (params) => {
  return req('get', '/console/pipeline-topic/deleteTopic', {
    ...params
  });
};
// 获取Topic列表
export const getTopicList = (params) => {
  return req('get', '/console/pipeline-topic/getList', {
    ...params
  });
};
// 根据kafka集群ID获取topic列表
export const getListByKafkaClusterID = (params) => {
  return req('get', '/console/pipeline-topic/getListByKafkaClusterID', {
    ...params
  });
};
